<template>
  <div>
    <!-- Alert: No item found -->
    <b-breadcrumb class="breadcrumb-slash mb-1">
      <b-breadcrumb-item :to="{ name: 'user-list' }">
        รายการผู้ใช้งาน (User)
      </b-breadcrumb-item>
      <b-breadcrumb-item active>
        ดูข้อมูล
      </b-breadcrumb-item>
    </b-breadcrumb>
    <template v-if="userDatas">
      <!-- First Row -->
      <!-- <b-row>
        <b-col cols="12" xl="12" lg="12" md="12">
          <user-view-user-info-card :user-data="userDatas" />
        </b-col>
      </b-row> -->

      <b-row>
        <b-col cols="12" lg="6">
          <user-view-user-permissions-card :user-data="userDatas" />
        </b-col>
        <!-- <b-col cols="12" lg="6">
          <user-view-user-timeline-card :user-data="userDatas" />
        </b-col> -->
      </b-row>

      <!-- <invoice-list /> -->
      <!-- <orders-list :shop-id="userDatas.shopId" /> -->
    </template>
  </div>
</template>

<script>
import store from "@/store";
import router from "@/router";
import { ref, onUnmounted } from "@vue/composition-api";
import {
  BRow,
  BCol,
  BAlert,
  BLink,
  BBreadcrumb,
  BBreadcrumbItem,
} from "bootstrap-vue";
import InvoiceList from "@/views/orders/invoice/invoice-list/InvoiceList.vue";
import userStoreModule from "../userStoreModule";
import UserViewUserInfoCard from "./MemberViewUserInfoCard.vue";
import UserViewUserTimelineCard from "./MemberViewUserTimelineCard.vue";
import UserViewUserPermissionsCard from "./MemberViewUserPermissionsCard.vue";
import OrdersList from "./OrdersList.vue";

export default {
  components: {
    BRow,
    BCol,
    BAlert,
    BLink,

    // Local Components
    UserViewUserInfoCard,
    UserViewUserTimelineCard,
    UserViewUserPermissionsCard,

    InvoiceList,
    OrdersList,
    BBreadcrumb,
    BBreadcrumbItem,
  },
  setup() {
    const userDatas = ref({
      userName: "",
      password: "",
      firstName: "",
      lastName: ""
    });

    // const USER_APP_STORE_MODULE_NAME = "app-user";

    // // Register module
    // if (!store.hasModule(USER_APP_STORE_MODULE_NAME))
    //   store.registerModule(USER_APP_STORE_MODULE_NAME, userStoreModule);

    // // UnRegister on leave
    // onUnmounted(() => {
    //   if (store.hasModule(USER_APP_STORE_MODULE_NAME))
    //     store.unregisterModule(USER_APP_STORE_MODULE_NAME);
    // });

    // store
    //   .dispatch("app-user/fetchUserOld", { id: 21 })
    //   .then((response) => {
    //     userData.value = response.data;
    //   })
    //   .catch((error) => {
    //     if (error.response.status === 404) {
    //       userData.value = undefined;
    //     }
    //   });
    const USER_APP_STORE_MODULE_NAME = "user-new";

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME))
      store.registerModule(USER_APP_STORE_MODULE_NAME, userStoreModule);

    store
      .dispatch("user-new/fetchUser", { id: router.currentRoute.params.id })
      .then((response) => {
        if (response.data) {
          userDatas.value = response.data;
        }
    
      })
      .catch((error) => {
        if (error.response.status === 404) {
          userDatas.value = undefined;
        }
      });
    return {
      userDatas,
    };
  },
};
</script>

<style></style>
